import React from 'react'
import { Route } from 'react-router'

import { PolicySearchList, PolicySearchView } from '.'

export const PolicySearch: React.FC = () => {
  // const [reportDate, setReportDate] = React.useState(null as Moment | null)
  const [dealerId, setDealerId] = React.useState(0)
  const [storeId, setStoreId] = React.useState(0)
  const [keyword, setKeyword] = React.useState('')
  const [currPage, setCurrPage] = React.useState(1)

  const handleDealerChange = (dealerId: number) => {
    setDealerId(dealerId)
    setStoreId(0)
  }

  return (
    <>
      <Route path="/policy/search" exact render={props => <PolicySearchList
        dealerId={dealerId} dealerOnChange={handleDealerChange}
        storeId={storeId} storeOnChange={setStoreId}
        keyword={keyword} keywordOnChange={setKeyword}
        currPage={currPage} currPageOnChange={setCurrPage}
        {...props} />} />
      <Route path="/policy/search/:id" component={PolicySearchView} />
    </>
  )
}